import { formatDate as ngFormatDate } from '@angular/common';
import { inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { formatDate as galaxyFormatDate, formatUTCDate } from '@vendasta/galaxy/utility/date-utils';

export enum formatting {
  datetime = 'y-MM-dd h:mm:ss a', //2018-01-25 11:54:39 AM
  date = 'y-MM-dd', //2018-01-25
  month = 'MMMM y', //January 2018
  utc = "yyyy-MM-dd'T00:00:00Z'", //2018-01-25T00:00:00Z
  longDate = 'dddd MMMM Do, YYYY', //Thursday January 25th, 2018
  shortSpoken = 'MMM d, y', //Jan 25, 2018
}

export function formatDate(
  date: Date | string,
  format: formatting,
  translateEmpty?: string,
  useLocalTime?: boolean,
  locale = 'en-US',
): string {
  translateEmpty = translateEmpty ? translateEmpty : '';
  if (!date) {
    return translateEmpty;
  }

  if (typeof date === 'string') {
    date = new Date(date);
    if (date.toString() === 'Invalid Date') {
      return date.toString();
    }
  }

  const timezone = format === formatting.utc || !useLocalTime ? 'UTC' : undefined;

  if (format === formatting.longDate) {
    return timezone === 'UTC'
      ? formatUTCDate(date, 'EEEE MMMM do, yyyy')
      : galaxyFormatDate(date, 'EEEE MMMM do, yyyy');
  }

  return ngFormatDate(date, format, locale, timezone);
}

@Pipe({
  name: 'formatDate',
  standalone: false,
})
export class FormatDatePipe implements PipeTransform {
  private readonly locale = inject(LOCALE_ID);

  transform(date: Date | string, format: formatting, translateEmpty?: string, useLocalTime?: boolean): string {
    return formatDate(date, format, translateEmpty, useLocalTime, this.locale);
  }
}
